<div class="grid grid-cols-1 items-start gap-x-6 gap-y-3 lg:grid-cols-[12.5rem_minmax(0,1fr)]">
  <!-- Stages, in the order of the phases -->
  <app-filter-rail class="-ml-2 block lg:sticky lg:top-44 lg:max-h-[calc(100vh-12rem)] lg:overflow-y-auto" label="Stufen" [groups]="groups()" [active]="active()" (picked)="pick($event)" />

  <div class="min-w-0 space-y-3 [&_app-analysis-reference]:!max-w-64">
    @if (store.itemsError()) { <app-state-panel state="error" title="Die Analysen konnten nicht geladen werden" description="Der Server hat nicht geantwortet. Es ist nichts verloren gegangen."><button hlmBtn type="button" variant="outline" (click)="store.loadItems()">Erneut laden</button></app-state-panel> }
    @if (runId()) {
      <button type="button" class="ks-toolbar-button border-primary text-primary" (click)="applyRunClear()">
        Nur Berechnung vom {{ runLabel() }} <ng-icon name="lucideX" class="size-3" />
      </button>
    }
    <app-analysis-table
      [isLoading]="isLoading()"
      [organizationId]="store.organizationId()!"
      [campaignId]="store.campaignId()!"
      [selectable]="true"
      [showAddButton]="false"
      [columnVisibility]="columnVisibility"
      [extraColumns]="columns()"
      [restrictToIds]="restrict()"
      [rowOpen]="rowOpen"
      [toolbarActions]="toolbarActions()"
      [selectionActions]="selectionTpl"
      (dataChanged)="reloadAnalyses()"
      (quickAction)="onQuickAction($event)"
    />
  </div>
</div>

<ng-template #selectionTpl>
  <app-exclude-reason label="Zurückstellen" triggerClass="ks-toolbar-button !h-7" [disabled]="busy()" (confirmed)="excludeSelection($event)" />
  <button hlmBtn type="button" variant="outline" size="sm" class="!h-7 text-xs" [disabled]="busy()" (click)="reviewSelection()">Prüfen</button>
  @if (store.canStart()) {
    <button hlmBtn type="button" size="sm" class="!h-7 text-xs" [disabled]="busy() || store.running()" (click)="runSelection()">Berechnen</button>
  }
</ng-template>

<ng-template #stageTpl let-analysis>
  @if (itemOf(analysis); as item) { <app-stage-chip [stage]="item.stage" /> }
</ng-template>
<ng-template #stepsTpl let-analysis>
  @if (itemOf(analysis); as item) {
    <span class="inline-flex items-center gap-[3px]" [title]="stepTitle(item)">
      @for (state of dots(item); track $index) {
        <span class="size-2 rounded-sm" [class]="state === 'done' ? 'bg-foreground' : state === 'warn' ? 'bg-warning' : state === 'err' ? 'bg-danger' : state === 'run' ? 'bg-primary/50' : 'bg-border'"></span>
      }
    </span>
  }
</ng-template>
<ng-template #noteTpl let-analysis>
  @if (itemOf(analysis); as item) { <span class="line-clamp-1 max-w-32 text-xs text-muted-foreground" [title]="note(item)">{{ note(item) }}</span> }
</ng-template>
<ng-template #kwpTpl let-analysis>
  @if (itemOf(analysis)?.planning?.kwp; as kwp) { <span class="whitespace-nowrap font-mono text-xs">{{ kwp | number: '1.1-1' : 'de-DE' }} kWp</span> } @else { <span class="text-muted-foreground">–</span> }
</ng-template>
<ng-template #paybackTpl let-analysis>
  @if (itemOf(analysis)?.planning?.payback; as payback) { <span class="whitespace-nowrap font-mono text-xs">{{ payback | number: '1.1-1' : 'de-DE' }} J</span> } @else { <span class="text-muted-foreground">–</span> }
</ng-template>
<ng-template #changedTpl let-analysis>
  @if (itemOf(analysis)?.updatedAt; as at) { <span class="whitespace-nowrap font-mono text-2xs text-muted-foreground">{{ at | date: 'dd.MM., HH:mm' }}</span> }
</ng-template>
